import {Component, Inject} from '@angular/core';
import {FormBuilder, FormControl, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {AuthService} from "../../../services/AuthService";
import {BasicEventPlayer} from "../../../entities/auth/BasicEventPlayer";
import {EventBooth} from "../../../entities/booths/EventBooth";

@Component({
  selector: 'app-edit-dialogue',
  templateUrl: './punish-dialogue.component.html',
  styleUrls: ['./punish-dialogue.component.css']
})
export class PunishDialogueComponent {
  types: string[] = ['BAN', 'MUTE']

  nameGroup = this._formBuilder.group({
    secondCtrl: ['', Validators.required],
  });
  typeGroup = this._formBuilder.group({
    secondCtrlb: ['', Validators.required],
  });
  ownerGroup = this._formBuilder.group({
    secondCtrlc: ['', Validators.required],
  });

  nameControl: FormControl;
  typeControl: FormControl;
  ownerControl: FormControl;

  permanent: boolean;

  constructor(private _formBuilder: FormBuilder,
              public dialogRef: MatDialogRef<PunishDialogueComponent>,
              private auth: AuthService,
              @Inject(MAT_DIALOG_DATA) public player: BasicEventPlayer) {
    this.nameControl = new FormControl();
    this.typeControl = new FormControl();
    this.ownerControl = new FormControl();
  }

  setPermanent(val: boolean) {
    this.permanent = val;
  }

  checkSaveDisabled(): boolean {
    if(this.permanent)
      return false;
    if(this.ownerControl.value === null)
      return true;
    if(this.ownerControl.value.length === 0)
      return true;
    return false;
  }

  save() {
    this.dialogRef.close({
      reason: this.nameControl.value,
      type: this.typeControl.value,
      expiry: this.permanent ? -1 : Date.parse(this.ownerControl.value)
    });
  }
}
